import { ReactElement } from 'react';

interface Props {
  className?: string;
}

function threePoints({ className }: Props): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 29.96 122.88"
      stroke="black"
      width="29.96"
      height="122.88"
      className={className}
    >
      <path
        fill="none"
        d="M15 0A15 15 0 110 15 15 15 0 0115 0zm0 92.93a15 15 0 11-15 15 15 15 0 0115-15zm0-46.47a15 15 0 11-15 15 15 15 0 0115-15z"
        className="cls-1"
      ></path>
    </svg>
  );
}

export default threePoints;
